import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "audience-management-table" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = ["contenteditable", "onKeypress", "onBlur", "onFocus"];
const _hoisted_8 = ["title"];
const _hoisted_9 = { key: 5 };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", { class: "audience-management-table__dropdown__button" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" })
], -1);
const _hoisted_11 = { class: "el-table__column" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
import { computed, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch, h } from 'vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import { formatDate, formatNumber } from '@/utilities/formatters';
import { moveCursorToEnd } from '@/utilities/dom';
import { fetchAudience, renameAudience } from '../data/';
import i18n from '@/i18n';
import router from '@/router';
import bus from '@/helpers/events/bus';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import ListPagination from '@/components/_atoms/ListPagination.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import AudienceManagementModalDelete from './AudienceManagementModalDelete.vue';
import AudiencesExportation from '@/components/audiences/exportation/AudiencesExportation.vue';
import { hasInvalidSpecialCharacters } from '@/utilities/validators/verifySpecialCharacters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceManagementTable',
    props: {
        search: {},
        selectedOption: {}
    },
    emits: ['initialLoading', 'verifyEmptyTable'],
    setup(__props, { emit }) {
        const props = __props;
        const toast = useToast();
        const store = useStore();
        const audienceNameRefs = ref([]);
        const state = reactive({
            selectedOption: { id: 'all', name: '' },
            tablePresets: {
                all: '',
                integration: '',
            },
            pagination: {
                limit: 10,
                page: 1,
                count: 0,
            },
            audienceToDelete: null,
            isLoading: false,
            searchValue: '',
            tableHeader: [],
            hasError: false,
            audienceToRename: {
                id: null,
            },
            isDeleteModalVisible: false,
            id: 'audience-management',
            sort: {
                prop: 'dtCreate',
                order: 'descending',
                clicks: 1,
                orderBy: '-dtCreate',
            },
            defaultOrdering: {
                all: '-dtCreate',
                integration: '-dtCreate',
            },
            originalName: '',
            isSearchTable: false,
            tableData: [],
            isExportVisible: false,
            exportAudience: null,
            isSubmittingNewName: false,
            hasErrorName: false,
        });
        // Computed
        const user = computed(() => store.getters.user);
        const emptyAudience = computed(() => !state.tableData.length && !state.tableHeader.length && !state.isLoading && state.pagination.count === 0);
        const initialLoading = computed(() => state.isLoading && !state.tableData.length && !state.tableHeader.length);
        const routeName = computed(() => {
            const routeName = String(router.currentRoute.value.path);
            return routeName;
        });
        // Helpers
        const getColumnName = (key) => {
            return state.tableHeader.filter(column => column.key === key)[0]['label'];
        };
        const getColumnWidth = (columnKey) => {
            const defaultWidth = 90;
            const widths = {
                name: 220,
                id: 80,
                user: 160,
                dtCreate: 150,
                actions: 40,
                basePeople: 100,
            };
            return widths[columnKey] || defaultWidth;
        };
        const tableRowClassName = ({ columnIndex }) => {
            return ['integrations', 'basePeople'].includes(state.tableHeader[columnIndex]['key']) ? 'metric' : 'dimension';
        };
        const setAudienceNameRef = (index, aud) => async (el) => {
            audienceNameRefs.value[index] = el;
            if (aud.userID === user.value.id) {
                const element = audienceNameRefs.value[index];
                await nextTick();
                if (element) {
                    element.focus();
                    moveCursorToEnd(element);
                }
            }
            return audienceNameRefs.value[index];
        };
        // Actions
        const verifySpecialCharacters = (event) => {
            const target = event.target;
            const editedText = target.innerText;
            const hasError = hasInvalidSpecialCharacters(editedText);
            state.hasErrorName = Boolean(hasError);
        };
        const exportAudience = (audience) => {
            if (audience.basePeople > 0) {
                state.exportAudience = audience;
                bus.$emit('open-exportation');
            }
        };
        const duplicateAudience = (audience) => {
            if (!audience.copyable) {
                toast.error({
                    render() {
                        return h('span', { innerHTML: i18n.global.t(`audiences.copyable`) });
                    },
                });
            }
            else {
                const routeName = String(router.currentRoute.value.name);
                const routeMap = {
                    'base-audiences': 'AudienceDuplicateNew',
                    'new-audiences-activation': 'AudienceDuplicate',
                };
                const matchedKey = Object.keys(routeMap).find(key => routeName.includes(key));
                const duplicateRoute = matchedKey ? routeMap[matchedKey] : 'AudienceDuplicate';
                router.push({ name: duplicateRoute, params: { id: audience.id } });
            }
        };
        const triggerRename = (audience) => {
            state.audienceToRename.id = audience.id;
        };
        const deleteAudience = (audience) => {
            state.isDeleteModalVisible = true;
            state.audienceToDelete = audience;
        };
        const onFocus = (audience) => {
            state.originalName = audience.name;
        };
        const renamingAudience = (event, audience) => {
            if (state.isSubmittingNewName)
                return;
            state.isLoading = true;
            const target = event.target;
            const editedText = target.innerText.trim();
            const MAX_CHARACTER_LIMIT = 100;
            if (state.hasErrorName)
                return;
            if (editedText.length > MAX_CHARACTER_LIMIT) {
                audienceNameRefs.value[0].textContent = state.originalName;
                toast.warning(i18n.global.t(`audiences.rename.max-char-limit`), { timeout: 10000 });
                state.isLoading = false;
            }
            if (editedText === '' || editedText === audience.name) {
                if (editedText === '') {
                    audienceNameRefs.value[0].textContent = state.originalName;
                    toast.warning(i18n.global.t(`audiences.rename.empty-text`), { timeout: 10000 });
                    state.isLoading = false;
                }
                state.audienceToRename.id = null;
                state.isLoading = false;
                return;
            }
            submitRename(editedText, audience);
        };
        const redirectToIntegrations = (audience) => {
            const isBaseAudiences = String(router.currentRoute.value.name) === 'base-audiences';
            router.push({
                name: isBaseAudiences ? 'AudienceDetailNew' : 'AudienceDetail',
                params: { id: audience.id, creator: audience.userID },
                query: { step: 'integrations' },
            });
        };
        // Fetch
        const submitRename = (editedText, audience) => {
            state.isLoading = true;
            state.isSubmittingNewName = true;
            renameAudience({
                audienceId: audience.id,
                name: editedText,
            })
                .then(response => {
                if (response) {
                    fetchDataTable();
                    toast.success(i18n.global.t(`audiences.rename.success`), { timeout: 10000 });
                    return;
                }
                toast.error(i18n.global.t(`audiences.rename.error`), {
                    timeout: 10000,
                });
            })
                .finally(() => {
                state.isSubmittingNewName = false;
                state.audienceToRename = { id: null };
            });
        };
        const fetchDataTable = async (typeFetch) => {
            state.isLoading = true;
            state.isSearchTable = false;
            state.tableData = [];
            if (typeFetch === 'initial') {
                emit('initialLoading', true);
            }
            if (typeFetch === 'search') {
                state.isSearchTable = true;
                resetPagination();
            }
            if (typeFetch === 'preset') {
                resetOrdering();
                resetPagination();
            }
            const params = {
                page: state.pagination.page,
                limit: state.pagination.limit,
                orderBy: state.sort.orderBy,
                type: state.selectedOption.id,
                term: state.searchValue,
            };
            await fetchAudience(params)
                .then(response => {
                if (!response.data.length && typeFetch !== 'search') {
                    state.tableData = [];
                    state.pagination.count = response.totalCount;
                    return;
                }
                state.tableData = response.data;
                state.tableHeader = response.columns;
                state.tableHeader.push({ label: '', type: 'string', key: 'actions' });
                state.pagination.count = response.totalCount;
            })
                .catch(() => {
                state.hasError = true;
            })
                .finally(() => {
                state.isLoading = false;
                state.isSearchTable = false;
                if (typeFetch === 'initial') {
                    emit('initialLoading', false);
                    emit('verifyEmptyTable', emptyAudience.value);
                }
            });
        };
        // Resets
        const resetOrdering = (value = '') => {
            state.sort = {
                prop: state.defaultOrdering[state.selectedOption.id],
                order: value === 'removeOrderBy' ? '' : 'descending',
                clicks: 1,
                orderBy: value === 'removeOrderBy' ? '' : state.defaultOrdering[state.selectedOption.id],
            };
        };
        const resetPagination = () => {
            state.pagination.page = 1;
        };
        // Sorting
        const sortTable = ({ prop }) => {
            state.sort.clicks = state.sort.prop === prop ? (state.sort.clicks += 1) : 0;
            if (state.sort.clicks === 3) {
                resetOrdering('removeOrderBy');
                fetchDataTable();
                return;
            }
            const isDefaultOrder = state.sort.orderBy && !state.sort.orderBy.includes('-') && state.sort.prop === prop;
            state.sort.prop = prop;
            if (isDefaultOrder) {
                state.sort.orderBy = `-${prop}`;
                state.sort.order = 'descending';
            }
            if (!state.sort.orderBy || !isDefaultOrder) {
                state.sort.orderBy = prop;
                state.sort.order = 'ascending';
            }
            fetchDataTable();
        };
        onMounted(() => {
            bus.$on('render-cards', () => {
                fetchDataTable();
            });
        });
        onBeforeUnmount(() => {
            bus.$off('render-cards');
        });
        // Watchers
        watch(() => props.search, value => {
            state.searchValue = value;
            fetchDataTable('search');
        });
        watch(() => props.selectedOption, preset => {
            state.selectedOption = preset;
            fetchDataTable('preset');
            resetOrdering();
        });
        const initialize = () => {
            fetchDataTable('initial');
        };
        initialize();
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_router_link = _resolveComponent("router-link");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AudienceManagementModalDelete, {
                    "is-visible": state.isDeleteModalVisible,
                    audience: state.audienceToDelete,
                    onResetDeleteAudience: _cache[0] || (_cache[0] = ($event) => (state.audienceToDelete = null)),
                    onResetModalVisibility: _cache[1] || (_cache[1] = ($event) => (state.isDeleteModalVisible = false))
                }, null, 8, ["is-visible", "audience"]),
                _createVNode(AudiencesExportation, {
                    audience: state.exportAudience
                }, null, 8, ["audience"]),
                _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createVNode(_component_el_table, {
                        class: _normalizeClass({ 'audience-management-table--disabled-columns': state.isSearchTable }),
                        data: state.tableData,
                        "scrollbar-always-on": true,
                        "cell-class-name": tableRowClassName,
                        style: { "width": "100%" },
                        stripe: "",
                        "empty-text": ' ',
                        "default-sort": state.sort,
                        onSortChange: sortTable
                    }, {
                        empty: _withCtx(() => [
                            (state.isLoading && !state.tableData.length)
                                ? (_openBlock(), _createBlock(BaseLoader, {
                                    key: 0,
                                    class: "audience-management-table__loading"
                                }))
                                : _createCommentVNode("", true),
                            (state.tableHeader.length && !state.isLoading)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 1,
                                    ref: "message-error",
                                    error: state.hasError,
                                    class: "audience-management-table__empty-table"
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.tableHeader, (column, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (!['userID', 'copyable'].includes(column.key))
                                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: 0,
                                            sortable: column.key === 'dtCreate',
                                            fixed: index === 0 ?? true,
                                            prop: column.key,
                                            label: column.label,
                                            "min-width": getColumnWidth(column.key)
                                        }, {
                                            default: _withCtx((scope) => [
                                                (column.key === 'integrations')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                        (scope.row.integrations)
                                                            ? (_openBlock(), _createBlock(_component_el_popover, {
                                                                key: 0,
                                                                trigger: "hover",
                                                                placement: "right",
                                                                width: 260
                                                            }, {
                                                                reference: _withCtx(() => [
                                                                    _createElementVNode("span", {
                                                                        class: "audience-management-table__integrations",
                                                                        onClick: ($event) => (redirectToIntegrations(scope.row))
                                                                    }, _toDisplayString(scope.row.integrations.quantity), 9, _hoisted_3)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("p", null, _toDisplayString(scope.row.integrations.name), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1024))
                                                            : (_openBlock(), _createElementBlock("span", {
                                                                key: 1,
                                                                class: "audience-management-table__integrations",
                                                                onClick: ($event) => (redirectToIntegrations(scope.row))
                                                            }, _toDisplayString(scope.row.integrations), 9, _hoisted_4))
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (column.key === 'dtCreate')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(formatDate)(scope.row.dtCreate, 'DD/MM/YYYY - HH:mm')), 1))
                                                    : _createCommentVNode("", true),
                                                (column.key === 'basePeople')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(formatNumber)(scope.row.basePeople)), 1))
                                                    : _createCommentVNode("", true),
                                                (column.key === 'name')
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 3,
                                                        class: _normalizeClass({ 'audience-management-table__renaming': state.audienceToRename.id === scope.row.id })
                                                    }, [
                                                        (state.audienceToRename.id === scope.row.id)
                                                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                                key: 0,
                                                                visible: state.hasErrorName,
                                                                "raw-content": true,
                                                                content: _ctx.$t('audiences.error-characters-name'),
                                                                placement: "right",
                                                                "popper-class": "el--tooltip-error suggestion-details-header__input--tooltip"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("span", {
                                                                        ref_for: true,
                                                                        ref: setAudienceNameRef(index, scope.row),
                                                                        class: "audience-management-table__name",
                                                                        contenteditable: state.audienceToRename.id === scope.row.id,
                                                                        onKeypress: _withKeys(_withModifiers(($event) => (renamingAudience($event, scope.row)), ["prevent"]), ["enter"]),
                                                                        onBlur: ($event) => (renamingAudience($event, scope.row)),
                                                                        onFocus: ($event) => (onFocus(scope.row)),
                                                                        onInput: _cache[2] || (_cache[2] = ($event) => (verifySpecialCharacters($event)))
                                                                    }, _toDisplayString(scope.row.name), 41, _hoisted_7)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["visible", "content"]))
                                                            : (_openBlock(), _createBlock(_component_router_link, {
                                                                key: 1,
                                                                to: `${routeName.value}/view/${scope.row.userID}/${scope.row.id}`
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["to"]))
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (column.key === 'user')
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 4,
                                                        title: scope.row.user,
                                                        class: "audience-management-table__user"
                                                    }, _toDisplayString(scope.row.user), 9, _hoisted_8))
                                                    : _createCommentVNode("", true),
                                                (column.key === 'actions')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _createVNode(_component_el_dropdown, {
                                                            trigger: "click",
                                                            class: "audience-management-table__dropdown"
                                                        }, {
                                                            dropdown: _withCtx(() => [
                                                                _createVNode(_component_el_dropdown_menu, null, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_el_dropdown_item, {
                                                                            onClick: ($event) => (triggerRename(scope.row)),
                                                                            disabled: scope.row.userID !== user.value.id
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.$t('rename')), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["onClick", "disabled"]),
                                                                        _createVNode(_component_el_dropdown_item, {
                                                                            disabled: scope.row.basePeople === 0,
                                                                            onClick: ($event) => (exportAudience(scope.row))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.$t('export')), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["disabled", "onClick"]),
                                                                        _createVNode(_component_el_dropdown_item, {
                                                                            onClick: ($event) => (duplicateAudience(scope.row))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.$t('duplicate')), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["onClick"]),
                                                                        _createVNode(_component_el_dropdown_item, {
                                                                            disabled: scope.row.userID !== user.value.id,
                                                                            onClick: ($event) => (deleteAudience(scope.row))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["disabled", "onClick"])
                                                                    ]),
                                                                    _: 2
                                                                }, 1024)
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _hoisted_10
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            header: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createElementVNode("label", null, _toDisplayString(getColumnName(column.key)), 1),
                                                    (column.key === 'basePeople')
                                                        ? (_openBlock(), _createBlock(_component_el_popover, {
                                                            key: 0,
                                                            trigger: "hover",
                                                            placement: "top",
                                                            width: 260,
                                                            class: "audience-management-table__tooltip"
                                                        }, {
                                                            reference: _withCtx(() => [
                                                                _hoisted_13
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createElementVNode("p", {
                                                                    innerHTML: _ctx.$t(`audiences.table.tooltips.${column.key}`)
                                                                }, null, 8, _hoisted_12)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _: 2
                                        }, 1032, ["sortable", "fixed", "prop", "label", "min-width"]))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["class", "data", "default-sort"]), [
                        [_vShow, state.tableHeader.length]
                    ]),
                    (initialLoading.value)
                        ? (_openBlock(), _createBlock(BaseLoader, { key: 0 }))
                        : _createCommentVNode("", true)
                ]),
                _withDirectives(_createVNode(ListPagination, {
                    data: state.pagination,
                    limit: state.pagination.limit,
                    "limit-range": [5, 10, 20, 30, 50],
                    identify: state.id,
                    "show-list-pages": false,
                    "show-quantity-lines": true,
                    onChangePage: fetchDataTable
                }, null, 8, ["data", "limit", "identify"]), [
                    [_vShow, !state.isLoading || state.pagination.count]
                ])
            ], 64));
        };
    }
});
